<template>
  <div class="media">
    <div class="media__grid" v-if="images && !addNewFile">
      <div class="media__element" v-for="(image, index) in images" :key="index">
        <div class="media-thumb" @click="selectImage(index)" :class="{'media-thumb--active': selected === index}">
          <div class="media-thumb__cover" >
            <img :src="image.images.thumb[0]" alt="" class="media-thumb__image">
          </div>
        </div>
      </div>
      <img src="/static/icons/nova/solid/add-circle-1.svg" alt="" @click="addNewFile = true" class="media__button">
    </div>
    <div class="media__upload" v-else>
      <div class="media__uploader">
        <h2 class="media__subtitle">SELECCIONE LA IMAGEN A SUBIR</h2>
        <div class="media__file">
          <input type="file" class="media__input" name="image" id="image" @change="uploadImage">
          <label for="image" class="media__input-text">SELECCIONE UNA IMAGEN</label>
        </div>
      </div>
      <img src="/static/icons/nova/solid/picture-layer-1.svg" alt="" @click.prevent="addNewFile = false" class="media__button">
    </div>
    <div class="media__options" v-if="selected !== null && !addNewFile">
      <button class="media__btns" @click.prevent="useImage">Seleccionar imagen</button>
      <button class="media__btns" @click.prevent="deleteImage">Borrar Imagen</button>
    </div>
  </div>
</template>

<script>
import httpService from '@/api/request'
export default {
  props: {
    name: {
      type: String,
      required: false,
      default: function () {
        return 'image'
      }
    }
  },
  mixins: [httpService],
  data: function () {
    return {
      images: null,
      selected: null,
      addNewFile: false
    }
  },
  created: function () {
    this.getImages()
  },
  methods: {
    getImages: function () {
      let httpRequest = {
        params: '',
        module: 'media'
      }
      this.get(httpRequest)
        .then(
          images => {
            this.images = images
          }
        ).catch(
          error => {
            console.log(error)
          }
        )
    },
    selectImage: function (index) {
      this.selected = index
    },
    useImage: function () {
      this.$parent.$parent.$emit(this.name, this.images[this.selected])
    },
    uploadImage: function (e) {
      let httpRequest = {
        params: '',
        module: 'media'
      }
      this.upload(e, httpRequest)
        .then(
          image => {
            this.images.push(image)
            this.addNewFile = false
          }
        )
    },
    deleteImage: function () {
      let httpRequest = {
        module: 'media'
      }
      let id = this.images[this.selected].id
      this.delete(id, httpRequest)
        .then(
          response => {
            this.images.splice(this.selected, 1)
            this.selected = null
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/components/layout/_media"
</style>



// WEBPACK FOOTER //
// src/components/media/browser.vue